export const THEMES = [
  { key: "dark", label: "Floodlights", desc: "Dark background, white text", bg: "#0B0F17", card: "#111827", text: "#FFFFFF", muted: "#94A3B8" },
  { key: "light", label: "Daylight", desc: "White background, near-black text", bg: "#FFFFFF", card: "#F3F4F6", text: "#0B0F17", muted: "#4B5563" },
  { key: "cream", label: "Chalk", desc: "Warm off-white, charcoal text", bg: "#F6F3EA", card: "#FFFFFF", text: "#1C1917", muted: "#57534E" },
];

const rgb = (hex) => [0, 2, 4].map((i) => parseInt(hex.replace("#", "").substr(i, 2), 16));
const toHex = (c) => `#${c.map((v) => Math.round(v).toString(16).padStart(2, "0")).join("")}`;
const lum = (hex) => {
  const [r, g, b] = rgb(hex).map((v) => {
    const s = v / 255;
    return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};
const contrast = (a, b) => {
  const [x, y] = [lum(a), lum(b)].sort((m, n) => n - m);
  return (x + 0.05) / (y + 0.05);
};
const mix = (hex, target, amt) => {
  const a = rgb(hex);
  const b = rgb(target);
  return toHex(a.map((v, i) => v + (b[i] - v) * amt));
};

export function teamInk(color = "#CCFF00", theme = "dark") {
  const t = THEMES.find((x) => x.key === theme) || THEMES[0];
  const toward = theme === "dark" ? "#FFFFFF" : "#000000";
  for (let amt = 0; amt <= 0.95; amt += 0.05) {
    const c = mix(color, toward, amt);
    if (contrast(c, t.bg) >= 4.5) return c;
  }
  return t.text;
}

export const themeClass = (theme) => `hub-themed hub-${theme || "dark"}`;
export const themeStyle = (theme, color) => ({ "--team-ink": teamInk(color, theme || "dark") });
export const themeBg = (theme) => (THEMES.find((x) => x.key === theme) || THEMES[0]).bg;
